<app-navbar-style-two></app-navbar-style-two>

<app-posnavbar></app-posnavbar>


<section class="pricing-area pt-4 pb-40">
    <div class="container">
        <div class="section-title text-center">
            <!-- <span>Pricing</span> -->
            <h2>Our Pricing Tables</h2>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-6">
                <div class="price-card">
                    <div class="content">
                        <!-- <i class="flaticon-deal"></i> -->
                        <h3>Bronze</h3>
                        <!-- <h2><sup>$</sup>60</h2> -->
                        <!-- <span>Only this week</span> -->
                    </div>
                    <ul>
                        <li>Suitable for small Pharmacy</li>
                        <li>Inventory Control</li>
                        <li>Basic Invoicing</li>
                        <li>Basic Accounting</li>
                        <li>No mobile App</li>
                        <li>51 Reports</li>
                    </ul>
                    <a class="default-btn" (click)="trynowbtn('MedeilCloud POS pricing Bronze Edition')">Start Trial</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="price-card">
                    <div class="content">
                        <!-- <i class="flaticon-megaphone"></i> -->
                        <h3>Silver</h3>
                        <!-- <h2><sup>$</sup>105</h2>
                        <span>Only this month</span> -->
                    </div>
                    <ul>
                        <li>Suitable for Medium size Pharmacy</li>
                        <li>Standard Inventory Control</li>
                        <li>Standard Inventory & Billing</li>
                        <li>Short expiry Management</li>
                        <li>Android version</li>
                        <li>75 Reports</li>
                    </ul>
                    <a class=" default-btn" (click)="trynowbtn('MedeilCloud POS pricing Silver Edition')">Start Trial</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                <div class="price-card">
                    <div class="content">
                        <!-- <i class="flaticon-diamond"></i> -->
                        <h3>Gold</h3>
                        <!-- <h2><sup>$</sup>134</h2>
                        <span>Only this year</span> -->
                    </div>
                    <ul>
                        <li>Suitable for Professional Pharmacy</li>
                        <li>Intelligent Inventory Management</li>
                        <li>Standards & Compliances inbuild</li>
                        <li>Loyality & Gift card</li>
                        <li>Both Android / IOS Version</li>
                        <li>137 Report</li>
                    </ul>
                    <a  class="default-btn" (click)="trynowbtn('MedeilCloud POS pricing Gold Edition')">Start Trial</a>
                </div>
            </div>
        </div>
    </div>
</section>
<ngx-smart-modal #myModal identifier="myModal" [closable]="false">

    <div class="custom-modal">
        <button class="close-btn" (click)="closepopup()">X</button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
        </div>
        <div class="modal-body">
         <form [formGroup]="enquiryForm">
           <div class="form-group">
             <label for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
           </div>
           <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Organisation</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
           </div>
           <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
             <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
              <div *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
              <div *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
            </div>
           </div>
           <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Country</strong></label>
             <!-- <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="countryname1"> -->
             <select class="form-control"  formControlName="countryname1" style="font-size: 13px;" (change)="countrychange()">
              <!-- (change)="countrychange()" -->
              <option select disabled value="0" >---Select Country---</option>
              <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>

            </select>
           </div>
           <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
             <div class="row">
               <div class="col-lg-3">
                 <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
               </div>
               <div class="col-lg-9">
                 <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                 autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
               </div>
             </div>

           </div>
           <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Description</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
           </div>
           <!-- <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Enter captcha</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name">
           </div> -->
           <label for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
           <div class="input-group">
              <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
               (change)="checkCaptcha()"/>
              <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
              [(ngModel)]="captcha"/>
              <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
            </div>
            <div *ngIf="ecaptcha">
              <p style="color: red">{{ errorcaptcha }}</p>
            </div>
           <div class="form-group">

                 <label class="container1 mt-3">I Accept Terms & Conditions & Privacy Policy
                     <input type="checkbox" checked="checked" formControlName="checkbox">
                     <span class="checkmark"></span>
                 </label>
           </div>
           <div  align="center" *ngIf="showElement">
            <img height="50px" width="50px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
          </div>
           <div class="btn-group mt-3" >
             <button type="button" class="enquiry-btn" (click)="savesignup()">Submit</button>

           </div>


         </form>
       </div>
    </div>

</ngx-smart-modal>
<div class="container">
    <div class="section-title text-center">
        <!-- <span>Pricing</span> -->
        <h2>Can’t decide which plan is right for you?</h2>

    </div>
    <div class="text-center">
        <button class="comparison" (click)="toggleComparison()">Click Here for Comparison table</button>
    </div>
    <div class="enquery" *ngIf="opencomparison">
        <form [formGroup]="comparisonform" class="form-container">

                <input type="text" formControlName="leadname" class="form-control" placeholder="Enter Name">
                <input type="number" formControlName="moblieno" class="form-control" placeholder="Enter Mobile">
                <input type="text" formControlName="emailid" class="form-control" placeholder="Enter Email">
                <div *ngIf="comparisonform.controls.emailid.invalid && (comparisonform.controls.emailid.dirty || comparisonform.controls.emailid.touched)">
                    <!-- <div *ngIf="comparisonform.controls.emailid.errors?.required" style="color: red;">Email is required.</div> -->
                    <div *ngIf="comparisonform.controls.emailid.errors?.pattern" style="color: red;">Invalid email format.</div>
                  </div>
                  <div  align="center" *ngIf="showgif">
                    <img height="100px" width="100px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
                  </div>
                <div class="btn-contain">
                    <button class="button-sub" role="button" (click)="savectable()">Submit</button>
                </div>



        </form>
    </div>

</div>
<div class="container mt-4">
    <div class="section-title text-center">
        <!-- <span>Pricing</span> -->
        <h2>Frequently Asked Questions</h2>
    </div>
    <div class="row pt-45">
        <div class="col-lg-6">
            <div class="faq-item">
                <h4>Q: Can I get a demo of MedeilCloud POS?</h4>
                <p><strong>A:</strong>
                    Yes, we would be happy to demonstrate Medeilcloud POS through a web-conference at your convenience between 9.30 AM to 6.30 PM. The demo is a 30 Minutes session. To schedule your personal session, please contact sales&#64;Vanuston.com</p>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="faq-item">
                <h4>Q: How flexible are your contracts?</h4>
                <p><strong>A:</strong>You are not bound by any contracts or commitments. Medeilcloud POS is a pay-as-you-go service (monthly or yearly), so you can make changes to your plan whenever you need to.</p>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="faq-item">
                <h4>Q: How does 14-days trial works?</h4>
                <p><strong>A:</strong>
                    When you sign up, you instantly get access to the fully loaded Edition for 14 days. We will email you when your trial expires. You can then select a plan and pay by credit card to continue using the product. If you choose not to continue, your account will be suspended.</p>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="faq-item">
                <h4>Q: Is my data safe?</h4>
                <p><strong>A:</strong>At Vanuston, we take data security seriously. Our Cloud servers are hosted in a world-class data centre that is protected by 24-hour surveillance and we ensure that our application is always up-to-date with the latest security patches.</p>
            </div>
        </div>
    </div>

</div>
<app-footer-style-two></app-footer-style-two>